import React from "react";
import { formatHoursToTime } from "utils/timesheet";

export const DisplayHours = ({
  value = 0,
  precision = 2,
  hoursOnly = false,
  format = true,
}) => {
  if (value === null) {
    return "-";
  }

  if (format) {
    return formatHoursToTime(value, { hoursOnly });
  }
  const numericValue =
    typeof value === "number" ? value : parseFloat(value || 0);
  return isNaN(numericValue) ? null : numericValue.toFixed(precision);
};
